import { render, staticRenderFns } from "./incl-siteNewsletter-recipients.vue?vue&type=template&id=9741f670&scoped=true"
import script from "./incl-siteNewsletter-recipients.vue?vue&type=script&lang=js"
export * from "./incl-siteNewsletter-recipients.vue?vue&type=script&lang=js"
import style0 from "./incl-siteNewsletter-recipients.vue?vue&type=style&index=0&id=9741f670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9741f670",
  null
  
)

export default component.exports